// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer_disclaimer__TUuFC","disabled":"Disclaimer_disabled__eBuch"};